export class WFCData {
    constructor() {
        this.tileSets = {};
        this.tilePieces = {};
    }
}
